var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testing__not-started block__content"},[_c('v-btn',{attrs:{"color":"primary ma-auto","dark":""},on:{"click":function($event){return _vm.$emit('start')}}},[_vm._v(" Начать тестирование ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }